import type { SVGProps } from "react";

export default function LayoutColumnsIcon(
  props: Readonly<SVGProps<SVGSVGElement>>,
) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="2.5"
        y="2.5"
        width="15"
        height="15"
        rx="2.5"
        stroke="currentColor"
        strokeWidth="1.25528"
      />
      <path d="M10 2.5V17.5" stroke="currentColor" strokeWidth="1.25528" />
    </svg>
  );
}
